import React from 'react';

import { relativeProgress } from '../Progress/Progress';

import styles from './Boost.scss';

export interface Props {
  boostRemaining?: number;
  currentPoints: number;
  targetPoints?: number;
}

const getBoostProgress = ({ boostRemaining, currentPoints, targetPoints }: Props): number => {
  const boostProgress =
    relativeProgress(targetPoints || 0, boostRemaining || 0) * 2 +
    relativeProgress(targetPoints || 0, currentPoints);
  return boostProgress <= 100 ? boostProgress : 100;
};

const Boost: React.FC<Props> = (props) => {
  const { boostRemaining, currentPoints, targetPoints } = props;

  if (!boostRemaining || boostRemaining === 0) {
    return null;
  }
  return (
    <span
      className={styles.progressBoost}
      style={{
        width: `${getBoostProgress({ boostRemaining, currentPoints, targetPoints })}%`
      }}
    >
      <div className={styles.after} />
      <div className={styles.glow} />
    </span>
  );
};

export default Boost;
